import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";
import SentryAppBoundary from "@/components/SentryAppBoundary";
import { registerServiceWorker } from "@/lib/pwa";

// Phase 122 — the HeyCatch SDK (Phase 94) has been removed. Site analytics
// are now first-party and cookie-free: see lib/siteAnalytics.js and the
// <SiteAnalyticsTracker /> mounted inside the router in App.js.

// Initialise Sentry as early as possible so any error during App render or
// hydration is captured. No-op when DSN env var is unset.
initSentry();

// Register the SplashPad Instructor PWA service worker. Safe to call
// unconditionally — the helper no-ops on localhost dev to avoid fighting
// with CRA's hot-reload, and on browsers without SW support.
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryAppBoundary>
      <App />
    </SentryAppBoundary>
  </React.StrictMode>,
);
